import { useEffect, useState } from 'react';

import { getCategories } from '../api/services/Riders';

type Category = { label: string; value: string };

export const useCategories = () => {
  const [categories, setCategories] = useState<Category[]>([]);

  useEffect(() => {
    const abortController = new AbortController();

    getCategories(abortController.signal)
      .then((result) => {
        if (result.type === 'success') {
          result.data.categories &&
            setCategories(
              result.data.categories.map((category) =>
                category.value === 'iep' ? { ...category, label: 'IEP / 504 / Special Needs' } : category
              )
            );
        }
      })
      .catch(() => null);

    return () => abortController.abort();
  }, []);

  const getLabelByValue = (value?: string) => {
    if (!value) {
      return null;
    }
    const categoryMatch = categories.find((category) => category.value === value);

    return categoryMatch?.label;
  };

  return { categories, getLabelByValue };
};
